"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonIconOnly = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("./Button");
var _Icon = require("../Icon");
var _styles = require("../../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var ButtonIconOnly = function ButtonIconOnly(_ref) {
  var onClick = _ref.onClick,
    type = _ref.type,
    size = _ref.size,
    icon = _ref.icon,
    disabled = _ref.disabled,
    otherButtonProps = _objectWithoutProperties(_ref, ["onClick", "type", "size", "icon", "disabled"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, _objectSpread({
    onClick: onClick,
    size: size,
    type: type,
    disabled: disabled
  }, otherButtonProps, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: icon,
      size: _styles.iconSizes.atom[size]
    })
  }));
};
exports.ButtonIconOnly = ButtonIconOnly;
ButtonIconOnly.defaultProps = {
  type: 'pink',
  size: 'm',
  disabled: false,
  icon: 'filter'
};